import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const shouldUseMiwiModSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('miwiMod'),
)

export default shouldUseMiwiModSelector
